import formatCurrency from '../../../../helpers/ConvertCurrencyToBRL';
import { Divider, PurchaseDetails, SectionTitle } from '../styles';
import { IPaymentState, } from '../types/types';

interface PurchaseSummaryProps {
  paymentState: IPaymentState;
  children?: React.ReactNode;
}

export const PurchaseSummary: React.FC<PurchaseSummaryProps> = ({
  paymentState,
  children,
}) => {
  const plan = paymentState.plan;
  const addons = paymentState.addons ?? [];
  const discountAmount = paymentState.discountAmount;
  const totalAmount = paymentState.finalPrice;
  const hasCoupon = Boolean(paymentState.couponId);

  return (
    <PurchaseDetails>
      <div className="purchase-details-container">
        <div className="purchase-details-header">
          <SectionTitle>Detalhes da compra</SectionTitle>

          <span className="info-icon" aria-label="Informações sobre a compra">i</span>
        </div>

        <div className="purchase-timeline">
          {plan && (
            <div className="purchase-section">
              <div className="price-row-label">
                Plano
              </div>

              <div className="price-row">
                <span className="item-description">
                  {plan.name} |{' '}
                  <span className="item-quantity">
                    1x item
                  </span>
                </span>

                <span className="price-value">
                  {formatCurrency(plan.amount)}
                </span>
              </div>
            </div>
          )}
          {addons.length > 0 && (
            <div className="purchase-section">
              <div className="price-row-label">
                Add-ons
              </div>

              {addons.map(addon => (
                <div
                  className="price-row"
                  key={addon.addon_id}
                >
                  <span className="item-description">
                    {addon.name} |{' '}
                    <span className="item-quantity">
                      {addon.item_count}x{' '}
                      {addon.item_count === 1
                        ? 'item'
                        : 'itens'}
                    </span>
                  </span>

                  <span className="price-value">
                    {formatCurrency(addon.total)}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>

        {hasCoupon && (
          <>
            <Divider />

            <div className="coupon-row">
              <span>
                {paymentState.couponCode
                  ? `Cupom ${paymentState.couponCode}`
                  : 'Cupom aplicado'}
              </span>

              {discountAmount > 0 && (
                <span>- {formatCurrency(discountAmount)}</span>
              )}
            </div>
          </>
        )}

        <Divider />

        <div className="summary-total-row">
          <span>Total</span>

          <span>
            {formatCurrency(totalAmount)}
          </span>
        </div>
      </div>

      <div className="purchase-details-footer">
        <div className="payment-today-row">
          <span>Total a pagar hoje</span>

          <strong>
            {formatCurrency(totalAmount)}
          </strong>
        </div>

        {children}
      </div>
    </PurchaseDetails>
  );
};
